export const PET_TYPES = [
  "Собаки",
  "Коти",
  "Птахи",
  "Рибки",
  "Гризуни",
  "Рептилії",
  "Сільськогосподарські тварини",
  "Одяг для тварин",
  "Аксесуари для тварин",
  "Інші",
];

export const petsFields = (attrs) => {
  const a = attrs || {};
  const type = a.type || "";

  const typeOnly = [
    {
      name: "type",
      label: "Тип",
      type: "select",
      options: PET_TYPES,
      required: true,
    },
  ];
  if (!type) return typeOnly;

  const dogCat = [
    { name: "breed", label: "Порода", type: "text", placeholder: "Наприклад: німецька вівчарка, мейн-кун" },
    { name: "age", label: "Вік", type: "text", placeholder: "Наприклад: 2 роки, 6 місяців" },
    { name: "gender", label: "Стать", type: "select", options: ["Самець", "Самка"] },
    { name: "vaccinated", label: "Щеплення", type: "select", options: ["Так", "Ні"] },
    { name: "documents", label: "Документи", type: "select", options: ["Є", "Немає"] },
  ];

  const otherAnimals = [
    { name: "breed", label: "Вид / Порода", type: "text", placeholder: "Наприклад: хвилястий папуга, хом’як сирійський" },
    { name: "age", label: "Вік", type: "text", placeholder: "Наприклад: 1 рік, 3 місяці" },
    { name: "gender", label: "Стать", type: "select", options: ["Самець", "Самка"] },
  ];

  const fish = [
    { name: "fishBreed", label: "Вид рибок", type: "text", placeholder: "Наприклад: гупі, скалярія" },
    { name: "age", label: "Вік", type: "text", placeholder: "Наприклад: 6 місяців" },
    { name: "withAquarium", label: "З акваріумом", type: "select", options: ["Так", "Ні"] },
  ];

  const clothes = [
    { name: "size", label: "Розмір", type: "text", placeholder: "Наприклад: S, M, L або 30 см по спинці" },
    { name: "condition", label: "Стан", type: "select", options: ["Новий", "Б/В"] },
  ];

  const accessories = [
    { name: "condition", label: "Стан", type: "select", options: ["Новий", "Б/В"] },
  ];

  if (["Собаки", "Коти"].includes(type)) {
    return [...typeOnly, ...dogCat];
  }
  if (["Птахи", "Гризуни", "Рептилії", "Сільськогосподарські тварини"].includes(type)) {
    return [...typeOnly, ...otherAnimals];
  }
  if (type === "Рибки") {
    return [...typeOnly, ...fish];
  }
  if (type === "Одяг для тварин") {
    return [...typeOnly, ...clothes];
  }
  if (type === "Аксесуари для тварин") {
    return [...typeOnly, ...accessories];
  }
  return typeOnly;
};
